export default {
  email: '邮箱',
  role: '角色',
  changeRoleTip: '更新信息后，用户需要重新登录后才会生效，您确定保存吗？',
  userId: '用户ID',
  checkFormat: '请检查电子邮件格式',
  checkNikeEmailFormat: '请输入正确的邮箱',
  deleteUserTip: '您确定要永久删除该用户吗？',
  greyMarketAccess: 'Grey Market Access'
}
